import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutUs from "../pages/about-us/page";
import OurTeam from "../pages/our-team/page";
import LifeAtAstroJal from "../pages/life-at-astrojal/page";
import HolidayList from "../pages/holiday-list/page";
import AiSolutions from "../pages/ai-solutions/page";
import Services from "../pages/services/page";
import LaravelDevelopment from "../pages/services/laravel/page";
import WebDevelopment from "../pages/services/web/page";
import MobileDevelopment from "../pages/services/mobile/page";
import ApiDevelopment from "../pages/services/api/page";
import SaasDevelopment from "../pages/services/saas/page";
import CloudDevops from "../pages/services/cloud/page";
import AiDevelopment from "../pages/services/ai/page";
import UiUxDesign from "../pages/services/ui-ux-design/page";
import MaintenanceSupport from "../pages/services/maintenance-support/page";
import HireLaravel from "../pages/services/hire/page";
import Industries from "../pages/industries/page";
import Healthcare from "../pages/industries/healthcare/page";
import Fintech from "../pages/industries/fintech/page";
import Ecommerce from "../pages/industries/ecommerce/page";
import Education from "../pages/industries/education/page";
import RealEstate from "../pages/industries/real-estate/page";
import Logistics from "../pages/industries/logistics/page";
import Travel from "../pages/industries/travel/page";
import SaasIndustry from "../pages/industries/saas/page";
import Enterprise from "../pages/industries/enterprise/page";
import MediaEntertainment from "../pages/industries/media-entertainment/page";
import Solutions from "../pages/solutions/page";
import Technologies from "../pages/technologies/page";
import LaravelTech from "../pages/technologies/laravel/page";
import PhpTech from "../pages/technologies/php/page";
import FlutterTech from "../pages/technologies/flutter/page";
import VueTech from "../pages/technologies/vue-js/page";
import ReactTech from "../pages/technologies/react/page";
import NodeTech from "../pages/technologies/node-js/page";
import AwsTech from "../pages/technologies/aws/page";
import AiTech from "../pages/technologies/ai-development/page";
import Portfolio from "../pages/portfolio/page";
import EnterpriseOpsCase from "../pages/portfolio/enterprise-operations-platform/page";
import AiSaasCase from "../pages/portfolio/ai-powered-saas-platform/page";
import HealthcareCase from "../pages/portfolio/healthcare-management-system/page";
import FintechCase from "../pages/portfolio/fintech-dashboard/page";
import EcommerceCase from "../pages/portfolio/ecommerce-platform/page";
import LogisticsCase from "../pages/portfolio/logistics-management-system/page";
import EducationCase from "../pages/portfolio/education-platform/page";
import MobileBusinessCase from "../pages/portfolio/mobile-business-application/page";
import AiCustomerSupportCase from "../pages/portfolio/ai-customer-support-assistant/page";
import BusinessCrmCase from "../pages/portfolio/business-crm-platform/page";
import ApiIntegrationCase from "../pages/portfolio/api-integration-platform/page";
import EnterpriseAnalyticsCase from "../pages/portfolio/enterprise-analytics-dashboard/page";
import Blog from "../pages/blog/page";
import BlogLaravelArchitecture from "../pages/blog/laravel-application-architecture/page";
import BlogLaravelApiBestPractices from "../pages/blog/laravel-api-development-best-practices/page";
import BlogScalableSaaS from "../pages/blog/how-to-build-a-scalable-saas-platform/page";
import BlogIntegratingAi from "../pages/blog/integrating-ai-into-laravel-applications/page";
import BlogLaravelPerformance from "../pages/blog/laravel-performance-optimization/page";
import BlogFlutterLaravel from "../pages/blog/building-flutter-apps-with-laravel-apis/page";
import BlogAwsDeployment from "../pages/blog/aws-deployment-strategies-for-laravel/page";
import BlogRedisCaching from "../pages/blog/redis-caching-in-laravel-applications/page";
import Contact from "../pages/contact-us/page";
import Careers from "../pages/careers/page";
import JobDetailPage from "../pages/careers/job-detail/page";
import GeneralApplyPage from "../pages/careers/apply/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsConditions from "../pages/terms-and-conditions/page";
import FaqPage from "../pages/faq/page";
import ProcessPage from "../pages/process/page";
import CtaOptionsPage from "../pages/cta-options/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about-us",
    element: <AboutUs />,
  },
  {
    path: "/our-team",
    element: <OurTeam />,
  },
  {
    path: "/life-at-astrojal",
    element: <LifeAtAstroJal />,
  },
  {
    path: "/holiday-list",
    element: <HolidayList />,
  },
  {
    path: "/ai-solutions",
    element: <AiSolutions />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/services/laravel-development",
    element: <LaravelDevelopment />,
  },
  {
    path: "/services/web-development",
    element: <WebDevelopment />,
  },
  {
    path: "/services/mobile-app-development",
    element: <MobileDevelopment />,
  },
  {
    path: "/services/api-development",
    element: <ApiDevelopment />,
  },
  {
    path: "/services/saas-development",
    element: <SaasDevelopment />,
  },
  {
    path: "/services/cloud-devops",
    element: <CloudDevops />,
  },
  {
    path: "/services/ai-development",
    element: <AiDevelopment />,
  },
  {
    path: "/services/ui-ux-design",
    element: <UiUxDesign />,
  },
  {
    path: "/services/maintenance-support",
    element: <MaintenanceSupport />,
  },
  {
    path: "/hire-laravel-developer",
    element: <HireLaravel />,
  },
  {
    path: "/industries",
    element: <Industries />,
  },
  {
    path: "/industries/healthcare",
    element: <Healthcare />,
  },
  {
    path: "/industries/fintech",
    element: <Fintech />,
  },
  {
    path: "/industries/ecommerce",
    element: <Ecommerce />,
  },
  {
    path: "/industries/education",
    element: <Education />,
  },
  {
    path: "/industries/real-estate",
    element: <RealEstate />,
  },
  {
    path: "/industries/logistics",
    element: <Logistics />,
  },
  {
    path: "/industries/travel",
    element: <Travel />,
  },
  {
    path: "/industries/saas",
    element: <SaasIndustry />,
  },
  {
    path: "/industries/enterprise",
    element: <Enterprise />,
  },
  {
    path: "/industries/media-entertainment",
    element: <MediaEntertainment />,
  },
  {
    path: "/solutions",
    element: <Solutions />,
  },
  {
    path: "/contact-us",
    element: <Contact />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/laravel-application-architecture",
    element: <BlogLaravelArchitecture />,
  },
  {
    path: "/blog/laravel-api-development-best-practices",
    element: <BlogLaravelApiBestPractices />,
  },
  {
    path: "/blog/how-to-build-a-scalable-saas-platform",
    element: <BlogScalableSaaS />,
  },
  {
    path: "/blog/integrating-ai-into-laravel-applications",
    element: <BlogIntegratingAi />,
  },
  {
    path: "/blog/laravel-performance-optimization",
    element: <BlogLaravelPerformance />,
  },
  {
    path: "/blog/building-flutter-apps-with-laravel-apis",
    element: <BlogFlutterLaravel />,
  },
  {
    path: "/blog/aws-deployment-strategies-for-laravel",
    element: <BlogAwsDeployment />,
  },
  {
    path: "/blog/redis-caching-in-laravel-applications",
    element: <BlogRedisCaching />,
  },
  {
    path: "/careers",
    element: <Careers />,
  },
  {
    path: "/careers/apply",
    element: <GeneralApplyPage />,
  },
  {
    path: "/careers/:slug",
    element: <JobDetailPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-and-conditions",
    element: <TermsConditions />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/process",
    element: <ProcessPage />,
  },
  {
    path: "/portfolio",
    element: <Portfolio />,
  },
  {
    path: "/portfolio/enterprise-operations-platform",
    element: <EnterpriseOpsCase />,
  },
  {
    path: "/portfolio/ai-powered-saas-platform",
    element: <AiSaasCase />,
  },
  {
    path: "/portfolio/healthcare-management-system",
    element: <HealthcareCase />,
  },
  {
    path: "/portfolio/fintech-dashboard",
    element: <FintechCase />,
  },
  {
    path: "/portfolio/ecommerce-platform",
    element: <EcommerceCase />,
  },
  {
    path: "/portfolio/logistics-management-system",
    element: <LogisticsCase />,
  },
  {
    path: "/portfolio/education-platform",
    element: <EducationCase />,
  },
  {
    path: "/portfolio/mobile-business-application",
    element: <MobileBusinessCase />,
  },
  {
    path: "/portfolio/ai-customer-support-assistant",
    element: <AiCustomerSupportCase />,
  },
  {
    path: "/portfolio/business-crm-platform",
    element: <BusinessCrmCase />,
  },
  {
    path: "/portfolio/api-integration-platform",
    element: <ApiIntegrationCase />,
  },
  {
    path: "/portfolio/enterprise-analytics-dashboard",
    element: <EnterpriseAnalyticsCase />,
  },
  {
    path: "/technologies",
    element: <Technologies />,
  },
  {
    path: "/technologies/laravel",
    element: <LaravelTech />,
  },
  {
    path: "/technologies/php",
    element: <PhpTech />,
  },
  {
    path: "/technologies/flutter",
    element: <FlutterTech />,
  },
  {
    path: "/technologies/vue-js",
    element: <VueTech />,
  },
  {
    path: "/technologies/react",
    element: <ReactTech />,
  },
  {
    path: "/technologies/node-js",
    element: <NodeTech />,
  },
  {
    path: "/technologies/aws",
    element: <AwsTech />,
  },
  {
    path: "/technologies/ai-development",
    element: <AiTech />,
  },
  {
    path: "/cta-options",
    element: <CtaOptionsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;